export default "__VITE_PUBLIC_ASSET__f95d4f50__"